'use client';
import { EpErrorMessage, EpStepContent, EpSwitch } from '../components';
import { useTranslation as t } from '../../../hooks/useTranslation';

export default function SafetyHuddleSwitch({
  translations,
}: {
  translations: unknown;
}) {
  return (
    <>
      <EpStepContent.Label label={t(translations, 'Audit/Safety Hudle')}>
        <EpSwitch
          switchName="safetyHuddleOrProactiveAction"
          switchLabel={t(
            translations,
            'This notification was generated from an audit/safety huddle or any proactive action:',
          )}
        />
      </EpStepContent.Label>
      <EpErrorMessage inputName="anonymous" />
    </>
  );
}
